import type { ReactNode } from "react";
import { BookOpen } from "lucide-react";

/** The centered frame around sign-in and account setup. */
export function AuthPage({ title, description, children }: { title: string; description?: ReactNode; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2">
          <BookOpen className="h-6 w-6" />
          <span className="text-lg font-semibold">RenTeller</span>
        </div>
        <h1 className="text-2xl font-bold">{title}</h1>
        {description && <p className="mt-1 mb-6 text-sm text-muted-foreground">{description}</p>}
        {!description && <div className="mb-6" />}
        {children}
      </div>
    </div>
  );
}
